import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { Table2 } from 'lucide-react';
import { t } from '@lingui/core/macro';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { withPermission } from '../../../withPermission';

export const DbStatsLayout = withPermission('canAccessDeveloperTools', () => {
  const { data: panels } = trpcAdmin.db.panels.useQuery();

  const items = useMemo<MenuItemsType[]>(
    () =>
      (panels ?? []).map((panel) => ({
        id: panel.id,
        label: panel.title,
        link: `/developer-tools/db-stats/${panel.id}`,
        icon: Table2,
      })),
    [panels],
  );

  return (
    <SidebarLayout items={items} label={t`DB Stats`} showCollapseButton={false}>
      <Outlet />
    </SidebarLayout>
  );
});
